module.exports = __webpack_public_path__ + "img/010_kibo.1776d714.jpg";